import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import anexo_1 from "../../assets/images/ModalInicio/ComunicadoSept2026/Anexo 1 - Comunicado DEPG (Agosto-2026).jpeg"
import anexo_2 from "../../assets/images/ModalInicio/ComunicadoSept2026/Anexo 2 - Comunicado DEPG (Agosto-2026).jpeg"
import anexo_3 from "../../assets/images/ModalInicio/ComunicadoSept2026/Anexo 3 - Comunicado DEPG (Agosto-2026).jpeg"
import anexo_4 from "../../assets/images/ModalInicio/ComunicadoSept2026/Anexo 4 - Comunicado DEPG (Agosto-2026).jpeg"
import thumbnail_1 from "../../assets/images/ModalInicio/ComunicadoSept2026/thumbnails/Anexo 1 - Comunicado DEPG (Agosto-2026) (thumbnail).png"
import thumbnail_2 from "../../assets/images/ModalInicio/ComunicadoSept2026/thumbnails/Anexo 2 - Comunicado DEPG (Agosto-2026) (thumbnail).png"
import thumbnail_3 from "../../assets/images/ModalInicio/ComunicadoSept2026/thumbnails/Anexo 3 - Comunicado DEPG (Agosto-2026) (thumbnail).png"
import thumbnail_4 from "../../assets/images/ModalInicio/ComunicadoSept2026/thumbnails/Anexo 4 - Comunicado DEPG (Agosto-2026) (thumbnail).png"
import { ModalGallery } from './ModalGallery';

const anexos = [
	{
		thumb: thumbnail_1,
		full: anexo_1,
		alt: "Anexo 1 - Comunicado DEPG (Agosto-2026).jpeg"
	},
	{
		thumb: thumbnail_2,
		full: anexo_2,
		alt: "Anexo 2 - Comunicado DEPG (Agosto-2026).jpeg"
	},
	{
		thumb: thumbnail_3,
		full: anexo_3,
		alt: "Anexo 3 - Comunicado DEPG (Agosto-2026).jpeg"
	},
	{
		thumb: thumbnail_4,
		full: anexo_4,
		alt: "Anexo 4 - Comunicado DEPG (Agosto-2026).jpeg"
	}
]

const ModalComunicado = ({ toggleFunction, modalState }) => {
	return (
		<Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
			<Modal.Header closeButton>
				<Modal.Title></Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<section className='info-container text-center'>
					<p className='heading-title fw-semibold mb-2 text-uppercase fs-base mb-4 mt-2'>Comunicado a la comunidad universitaria y al público en general</p>

					<div className='info-group d-flex flex-column gap-3 text-justify'>
						<p>La Dirección de la División de Estudios para Graduados de la Facultad de Medicina de la Universidad del Zulia considera necesario informar y aclarar que el médico cirujano Antwan Shamir Marín Lomelí ingresó en enero de 2023 como cursante del Programa de Posgrado de Cirugía General, con sede en el Hospital General del Sur «Dr. Pedro Iturbe».</p>

						<p>Tras su designación como director de dicho hospital por la autoridad asistencial competente, en agosto de 2024, y una vez conocida públicamente esa designación, el Consejo Técnico de la División de Estudios para Graduados, en ejercicio de sus atribuciones legales y a solicitud del director de la División, conoció el caso en la primera sesión celebrada después del período vacacional. </p>

						<p>En la Sesión Ordinaria N.º 08, realizada el 25 de septiembre de 2024, el Consejo Técnico aprobó por unanimidad la desincorporación del mencionado médico del referido Programa de Posgrado. </p>

						<p>Esta decisión fue comunicada al Colegio de Médicos del Estado Zulia en dos oportunidades, mediante comunicaciones de fechas 10 de enero de 2025 y 10 de abril de 2026. </p>

						<p>Se deja expresa constancia de que, desde el 25 de septiembre de 2024, el médico cirujano Antwan Shamir Marín Lomelí no es estudiante activo del Programa de Posgrado de Cirugía General. Asimismo, hasta la presente fecha no se ha producido ninguna decisión académica posterior que modifique su condición de desincorporado. </p>

						<p>En consecuencia, se emite la presente aclaratoria para conocimiento general y con el propósito de despejar cualquier duda respecto de las actuaciones académicas y administrativas realizadas por la División de Estudios para Graduados en relación con este caso. </p>

						<p>Atentamente, </p>

						<div className='p-list mb-4'>
							<p>Dr. Freddy Pachano Arenas</p>
							<p>Director de la División de Estudios para Graduados </p>
							<p>Facutad de Medicina</p>
							<p>Universidad del Zulia</p>
						</div>

						<p className='fw-semibold mb-0'>Anexos: </p>

						<ModalGallery images={anexos} />
					</div>
				</section>
			</Modal.Body>
			<Modal.Footer>
				<Button className='footer-button' variant="secondary" onClick={() => toggleFunction(false)}>
					Cerrar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export { ModalComunicado }